import type { IntegrationProviderConfig } from '../../types';
import HubSpotConnectionCard from './HubSpotConnectionCard';
import HubSpotIcon from './HubSpotIcon';

export const hubSpotConfig: IntegrationProviderConfig = {
  id: 'hubspot',
  name: 'HubSpot',
  icon: HubSpotIcon,
  brandColor: '#FF7A59',
  authMethod: 'oauth2',
  ConnectionCard: HubSpotConnectionCard,
  supportsPull: false,
  supportsPush: false,
  description:
    'Sync HubSpot contacts, companies, and deals with your FluxPrompt automations.',
  category: ['crm'],
  keywords: ['contacts', 'sales', 'marketing', 'companies', 'deals'],
  docsUrl: 'https://developers.hubspot.com/docs/api/overview',
  priority: 86,
  supportsSharing: false,
};
